import React from "react";
import Skeleton from "react-loading-skeleton";
import ServicePreferencesForm from "./components/ServicePreferencesForm";
import useServicePreferences from "./hooks/useServicePreferences";
import { Accordion } from "../../components";
import { ErrorMessage, ErrorMessageWrapper } from "../../components/messages";

const ClientServicePreferencesError = ({ error = "", retryCallback, ...rest }) => {
    const handleRetry = (e) => {
        e.preventDefault();
        if (retryCallback && typeof (retryCallback) === 'function') {
            retryCallback(e);
        }
    };

    return (
        <ErrorMessageWrapper margin="0px auto" maxWidth="600px" {...rest}>
            <ErrorMessage flex="column" error={error} retryCallback={handleRetry} />
        </ErrorMessageWrapper>
    );
};

const ClientServicePreferencesLoader= () => {
    return <Skeleton count={3} height={32} />
};

const ClientServicePreferences = ({ label = "Service & Custody Preferences", masterAccountId }) => {
    const { data, error, isError, isLoading, reload, update } = useServicePreferences(masterAccountId);

    const onFieldChanged = (property, value) => update(property, value);

    return (
        <Accordion defaultActiveKey="0" gap={1} label={label}>
            {isLoading && (
                <ClientServicePreferencesLoader />
            )}
            {!isLoading && (isError || error || !data) && (
                <ClientServicePreferencesError error={error} retryCallback={reload} />
            )}
            {!isLoading && !isError && data && (
                <ServicePreferencesForm data={data} onFieldChanged={onFieldChanged} />
            )}
        </Accordion>
    );
};

export default ClientServicePreferences;